export default __webpack_public_path__ + "static/media/medium_white.04849cd6.png";